import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "dashboard" }
const _hoisted_2 = { class: "dashboard__content" }
const _hoisted_3 = { class: "row m-0 welcome__row" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "h2" }
const _hoisted_6 = { class: "h2 word-blue username" }
const _hoisted_7 = { class: "row m-0 welcome__row" }
const _hoisted_8 = { class: "welcome__col" }
const _hoisted_9 = { class: "welcome__card-top" }
const _hoisted_10 = { class: "fz-bigger welcome__card-title" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["href", "onClick"]
const _hoisted_13 = { class: "welcome__col" }
const _hoisted_14 = {
  class: "icon",
  width: "48",
  height: "48",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "welcome__card-text" }
const _hoisted_17 = { class: "welcome__card-title" }
const _hoisted_18 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dashboard_sidebar = _resolveComponent("dashboard-sidebar")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_account_manager = _resolveComponent("app-account-manager")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_dashboard_sidebar),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, [
            _createVNode(_component_i18n_t, { keypath: "dashboard.welcome" })
          ]),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.userFullName), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (!_ctx.isProspect && _ctx.canShowOrdersPage)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "welcome__card",
                style: _normalizeStyle({
                            backgroundImage: `url(${
                                _ctx.storageApi + _ctx.filteredPageData.top_card_background
                            })`,
                        })
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.filteredPageData.top_card_title), 1),
                  _createElementVNode("div", {
                    innerHTML: _ctx.filteredPageData.top_card_description
                  }, null, 8, _hoisted_11),
                  _createVNode(_component_router_link, {
                    to: "/auth/my-carconnex/my-orders/to_approve",
                    custom: ""
                  }, {
                    default: _withCtx(({ navigate, href }) => [
                      _createElementVNode("a", {
                        class: "button button--sm button--outline",
                        href: href,
                        onClick: _withModifiers(($event: any) => (
                                        _ctx.appCompanyStatusDialogModel.show() || navigate()
                                    ), ["prevent"])
                      }, [
                        _createVNode(_component_i18n_t, { keypath: "dashboard.viewDetailsBtn" })
                      ], 8, _hoisted_12)
                    ]),
                    _: 1
                  })
                ])
              ], 4))
            : _createCommentVNode("", true),
          (!_ctx.shouldHideAccountManager)
            ? (_openBlock(), _createBlock(_component_app_account_manager, { key: 1 }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredPageData.sections, (icon) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: icon,
              class: "welcome__card--sm",
              to: '/auth' + icon.attributes.link
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock("svg", _hoisted_14, [
                  _createElementVNode("image", {
                    href: _ctx.storageApi + icon.attributes.icon,
                    width: "48",
                    height: "48"
                  }, null, 8, _hoisted_15)
                ])),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("p", _hoisted_17, _toDisplayString(icon.attributes.title), 1),
                  _createElementVNode("p", {
                    class: "fz-smaller welcome__card-subtitle",
                    innerHTML: icon.attributes.description
                  }, null, 8, _hoisted_18)
                ])
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ])
      ])
    ])
  ]))
}